export var notification = (function() {
    var self = {};
    self.settings = {
        status: 'info',
        type: 'snackbar',
        hideTime: 8000,
        defaultDismissMsg: 'Rozumím',
        defaultActionMsg: 'Více informací',
        defaultDataId: 'notification'
    };

    self.construct = function (id, message, dismissText, actionText, type, status, dataId, img) {
        var string = '';
        type = type ? type : notification.settings.type;
        status = status ? status : notification.settings.status;
        dismissText = dismissText ? dismissText : notification.settings.defaultDismissMsg;
        actionText = actionText ? actionText : notification.settings.defaultActionMsg;
        dataId = dataId ? dataId : notification.settings.defaultDataId;
        if(typeof message === 'undefined') {
            return console.error('No notification message found!');
        }
        if(type !== 'banner' && type !== 'snackbar') {
            console.error('Type '+ type +' is not valid notification type! Using default.');
        }
        if(status != 'error' && status != 'warning' && status != 'success' && status != notification.settings.status) {
            console.error('Status '+ status +' is not valid notification status! Using default.');
        }
        if(img != undefined && type == 'snackbar') {
            string += 
            '<div class="c-alert__icon">\
                <img src="'+ img + '" width="30px" height="20px" aria-hidden="true"/></div>';
        }
            string += 
                '<div class="c-alert__content">';

                if(img != undefined && type == 'banner') {
                    string +=  '\
                    <div class="c-alert__icon">\
                        <img src="'+ img + '" width="30px" height="20px" aria-hidden="true"/>\
                    </div>'; 
                }

                string += message +'\
                </div>\
                <div class="c-alert__action">\
            ';

            if(type == 'banner') {
                string +=
                '<button \
                    class="c-btn c-btn--clear"\
                    notification-action="notificationAction"\
                >\
                    '+ actionText +'\
                </button>\
                ';
            }

            string +=
                '<button \
                    class="c-btn c-btn--clear"\
                    notification-dismiss="' + id +'"\
                >\
                    '+ dismissText +'\
                </button>\
                ';
            string +=
                '</div>';

        var el = document.createElement('aside')
        el.classList.add("c-alert", "u-mb-20");
        el.setAttribute('data-id', dataId)
        if (type == 'banner') {
            el.classList.add("c-alert--banner");
        } else {
            el.classList.add("c-alert--snackbar");
        }
        if(status == 'warning') {
            el.classList.add("c-alert--warning");
        } else if (status == 'success') {
            el.classList.add("c-alert--success");
        } else if (status == 'error') {
            el.classList.add("c-alert--error");
        }
        el.setAttribute("id", id);
        el.innerHTML = string.trim();
        return el;
    };

    self.create = function(message, dismissText, actionText, type, status, img) {
        var id = 't' + Math.random().toString(36).substring(7);
        
        var el = self.construct(id, message, dismissText, actionText, type, status, img);
        var area = document.getElementById('l-notification');
        area.appendChild(el);
        el.classList.add('is-show');
        if(el.classList.contains('c-alert--snackbar')) {
            setTimeout(function () {
                self.hide(id)
            }, self.settings.hideTime);
        }
        var eventDismiss = document.querySelector('[notification-dismiss="' + id + '"]');
        eventDismiss.addEventListener("click", function() {
            self.hide(id);
        });
        if(type == 'banner') {
            var eventAction = document.querySelector('[notification-action="notificationAction"]');
            eventAction.addEventListener("click", function() {
                return notificationAction()
            });
        }
    };

    self.hide = function(id) {
        var el = document.getElementById(id)
        el.classList.remove('is-show');
        el.classList.add('is-hidden');
        setTimeout(function () {
            el.remove();
        }, 800);
    };

    return self;
})();
